module.exports = __webpack_public_path__ + "static/media/TeamEmailIcon.ff7701af.png";